import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$gte } from '../../utils/query-helpers';

const REQUIRED_FIELDS_PAST = {
  $and: [
    // Must provide activity type and description
    {
      activityId: {
        $null: false
      }
    },
    {
      siteId: {
        $null: false
      }
    },
    {
      interactionDescription: {
        $not: ''
      }
    },
    // Date must be provided
    {
      $or: [
        {
          $and: [
            {
              specificDate: 'Yes'
            },
            {
              date: {
                $null: false
              }
            }
          ]
        },
        {
          $and: [
            {
              specificDate: 'No'
            },
            {
              startDate: {
                $null: false
              }
            },
            {
              endDate: {
                $null: false
              }
            }
          ]
        }
      ]
    },
    // Must specify a participant
    {
      ...tags_type_count_$gte(TagTypes.Participant, 1)
    },
    // Must specify a method of interaction
    {
      ...tags_type_count_$gte(TagTypes.InteractionType, 1)
    },
    // Must be visible, completed, and not cancelled
    {
      cancelled: false
    },
    {
      completed: true,
    },
    // {
    //   showInGallery: true
    // }
  ]
}

export default REQUIRED_FIELDS_PAST;
